import TextField from "@mui/material/TextField";

import WebService from "../util/webService";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { getRandomInt, printVariable, searchSchool } from "../util/helper";
import {
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  Menu,
  Typography,
} from "@mui/material";
import useDelegate from "@hooks/useDelegate";
import { Fragment, useEffect, useMemo, useRef, useState, forwardRef, useImperativeHandle  } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FlatButton from "@components/FlatButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { makeStyles } from "@mui/styles";
import Select from "@mui/material/Select";
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator";
import useAlert from '@hooks/useAlert'
import useSnackbar from '@hooks/useSnackbar';
import Dialog from '@mui/material/Dialog';
import ConfirmDialog from "@components/ConfirmDialog";
import { detectBrowser } from "@util/helper";
import moment from "moment";

let mediaRecorder
let recordedBlobs = []


export default function TestPerformancePage() {
  const format = 'YYYY-MM-DD HH:mm:ss.SSS'
  const [resp, set_resp]  = useState('')
  const [startTime, set_startTime] = useState(moment())
  const [endTime, set_endTime] = useState(moment())

  const onLoad = async() => {
    const url = `/public/regi/perform`
    const resp = await WebService.post(url)
    console.log(resp)
    set_endTime( moment() )
    
    set_resp(JSON.stringify(resp)) 
  } 

  useEffect(() => {
    onLoad()
  }, [])
  return (
    <div>
      <Typography>
        startAt: {startTime.format(format)} endAt: {endTime.format(format)}
      </Typography>
      <Typography>
        diff ms: {endTime.diff(startTime)} ms
      </Typography>
      <Typography>{resp}</Typography>
    </div>
   )
    
}
